import React, { Fragment } from "react";
import { Box, Flex, Heading } from "rebass";
import { css } from "styled-components";

import { shortcutList } from "../../../../constants/shortcuts";

const PADDING = "20px";

const gridCSS = css`
  display: grid;
  grid-template-rows: auto;
  grid-auto-rows: minmax(54px, auto);
  grid-template-columns: auto max-content;
`;

const keyWrapperCSS = css`
  position: relative;

  & + & {
    padding-left: 23px;

    &:before {
      content: '+';
      position: absolute;
      top: 50%;
      left: ${23 / 2}px;
      transform: translate(-50%, -50%);
    }
  }
`;

export const Route: React.FC = () => (
  <Flex
    height="100%"
    flexDirection="column"
    p="65px 100px 35px"
  >
    <Heading
      as="h3"
      mb="30px"
      color="#2b3160"
      fontSize="30px"
      fontWeight="bold"
      lineHeight={1.07}
    >
      Shortcuts
    </Heading>

    <Box css={gridCSS}>
      {["action", "shortcut"].map((key) => (
        <Heading
          key={key}
          as="h4"
          mb="12px"
          pl={PADDING}
          fontSize="14px"
          color="#9b9eb5"
          css="text-transform: uppercase;"
        >
          {key}
        </Heading>
      ))}

      {shortcutList.map(({ id, action, combination }) => (
        <Fragment key={id}>
          <Flex
            alignItems="center"
            my="2px"
            pl={PADDING}
            bg="white"
          >
            {action}
          </Flex>

          <Flex
            alignItems="center"
            my="2px"
            px={PADDING}
            bg="white"
          >
            {combination.map(key => (
              <Box
                key={key}
                css={keyWrapperCSS}
              >
                <kbd>{key}</kbd>
              </Box>
            ))}
          </Flex>
        </Fragment>
      ))}
    </Box>
  </Flex>
);
